import ConfigStore from '../stores/Config';
import { isExperimentEnabled } from './hiveMind';
import {
  OLA_AUTOSAVE_STARTER_SERVICES_AA,
  OLA_AUTOSAVE_STARTER_SERVICES_AB
} from '../../constants/experiments';

// True when the AB treatment should render. Reads AA + AB behind the same first-visit gate so both enroll the same population.
export const isAutoSaveStarterServicesEligible = ({ isFirstTimeEditorVisit }) => {
  if (!isFirstTimeEditorVisit) {
    return false;
  }

  isExperimentEnabled(ConfigStore, OLA_AUTOSAVE_STARTER_SERVICES_AA);

  return isExperimentEnabled(ConfigStore, OLA_AUTOSAVE_STARTER_SERVICES_AB);
};
